<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {}
};
</script>

<style lang="scss">
#app {
  height: 100vh;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url("./assets/background.jpg");
  background-size: cover;
  margin: 0;
}

body {
  margin: 0;
  width: 100vw;

  .back-button {
    position: absolute;
    top: 15px;
    left: 15px;
  }

  .users-button {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .share-button {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  /deep/ .el-dialog {
      width: 50%;
    }

  @media only screen and (max-width: 400px) {
    /deep/ .el-dialog {
      width: 90%;
    }
  }

  .main {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px;
      width: 750px;
      min-height: 450px;
      background: rgba(32, 35, 40, 0.6);
      color: white;
      border-radius: 15px;
      margin: 15px;

      @media only screen and (max-width: 400px) {
          width: 90%;
      }

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
      }

      .header {
        position: relative;
        height: 65px;
        width: 100%;
      }

      .el-input {
        width: 275px;

        input {
          line-height: 30px;
        }
      }
    }
  }
}
</style>
